import { gql } from 'apollo-boost';
import { GET_USER_FRAGMENT } from '../fragments/user-fragment';

export const GET_USER_GQL = gql`
  ${GET_USER_FRAGMENT}
  query User($id: ID!) {
    user(id: $id) {
      ...userFragment
    }
  }
`;
